enum InboxParameter {

    Text = "text",
    TrKey = "trKey",
    TrParams = "trParams",
    Id = "id",
    SymbolId = "symbolId",
    Direction = "direction",
    Units = "units",
    OrderRate = "orderRate",
    TradeType = "tradeType"
}

export default InboxParameter;
